import classNames from "classnames";
import styles from "./style.module.scss";
import CustomModal from "shared/components/common/customModal";
import { Icons } from "assets";
import moment from "moment";

interface Details {
  id: number;
  name: string;
  email: string;
  support_message_type: string;
  message: string;
  created_at: Date;
}

interface Props extends ModalProps {
  details: Details;
}

const SupportViewModal = ({ details, show, handleClose }: Props) => {
  return show ? (
    <CustomModal>
      <div className={classNames(styles.contentContainer)}>
        <div
          className={classNames(
            "flex items-center justify-between px-4 mt-4 mb-3"
          )}
        >
          <h3 className={styles.modalTitle}>{"Details"}</h3>
          <div
            className={classNames(styles.crossContainer)}
            onClick={() => handleClose()}
          >
            <Icons.Cross />
          </div>
        </div>

        <div
          className={classNames(styles.modalBody, "w-full flex flex-col gap-4")}
        >
          <div
            className={classNames(styles.customerDetails, "grid grid-cols-12")}
          >
            <p className={classNames(styles.heading, "col-span-4")}>
              <strong>Name:</strong>
            </p>
            <p className={classNames(styles.value, "col-span-8")}>
              {details?.name || "N/A"}
            </p>
          </div>
          <div
            className={classNames(styles.customerDetails, "grid grid-cols-12")}
          >
            <p className={classNames(styles.heading, "col-span-4")}>
              <strong>Email:</strong>
            </p>
            <p className={classNames(styles.value, "col-span-8")}>
              {details?.email || "N/A"}
            </p>
          </div>
          <div
            className={classNames(styles.customerDetails, "grid grid-cols-12")}
          >
            <p className={classNames(styles.heading, "col-span-4")}>
              <strong>Category:</strong>
            </p>
            <p className={classNames(styles.value, "col-span-8")}>
              {details?.support_message_type || "N/A"}
            </p>
          </div>
          <div
            className={classNames(styles.customerDetails, "grid grid-cols-12")}
          >
            <p className={classNames(styles.heading, "col-span-4")}>
              <strong>Message:</strong>
            </p>
            <p className={classNames(styles.value, "col-span-8")}>
              {details?.message || "N/A"}
            </p>
          </div>
          <div
            className={classNames(styles.customerDetails, "grid grid-cols-12")}
          >
            <p className={classNames(styles.heading, "col-span-4")}>
              <strong>Date:</strong>
            </p>
            <p className={classNames(styles.value, "col-span-8")}>
              {moment(details?.created_at).format("MMM DD, YYYY")}
            </p>
          </div>
        </div>
      </div>
    </CustomModal>
  ) : null;
};

export default SupportViewModal;
